import { Component, Output, EventEmitter, signal, computed } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-message-input',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './message-input.html',
  styleUrls: ['./message-input.scss'],
})
export class MessageInputComponent {
  @Output() messageSent = new EventEmitter<string>();
  @Output() typing = new EventEmitter<void>();

  text = signal('');
  canSend = computed(() => this.text().trim().length > 0);
  private typingTimeout: ReturnType<typeof setTimeout> | null = null;

  onKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      this.send();
    }
  }

  onTextInput(event: Event): void {
    const value = (event.target as HTMLTextAreaElement).value;
    this.text.set(value);

    // Throttle typing indicator to at most once per 2 s
    if (!this.typingTimeout) {
      this.typing.emit();
      this.typingTimeout = setTimeout(() => {
        this.typingTimeout = null;
      }, 2000);
    }
  }

  send(): void {
    const trimmed = this.text().trim();
    if (!trimmed) return;
    this.messageSent.emit(trimmed);
    this.text.set('');
  }
}
